import React, { useState, useEffect } from 'react'
import DatePicker from 'react-date-picker';
import Select from 'react-select';
import axios from "axios";
import { APIURL } from "../../../Global";
import { Modal } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import moment from 'moment'
import { useAlert } from 'react-alert';
function AddSchedule(props) {
    const [daysOfaWeek, setdaysOfWeek] = useState([])
    const [startDate, setStartDate] = useState('')
    const [endDate, setEndDate] = useState('')
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [isOnline, setIsonline] = useState(false)
    const [slot, setSlot] = useState([])
    const [load, setLoad] = useState(false)
    const [frequency, setFrequency] = useState({ value: "daily", label: "Weekly" })
    const alert = useAlert()
    const [copy, setCopy] = useState({
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false,
        sunday: false
    })
    const [refresh, setRefresh] = useState(false)
    const [error, setError] = useState({})
    const [flag, setFlag] = useState('')
    const [radioCheck, setRadioCheck] = useState('')
    const timeOptions = [
        { value: '07:30:00', label: '07:30:00' },
        { value: '08:00:00', label: '08:00:00' },
        { value: '08:30:00', label: '08:30:00' },
        { value: '09:00:00', label: '09:00:00' },
        { value: '09:30:00', label: '09:30:00' },
        { value: '10:00:00', label: '10:00:00' },
        { value: '10:30:00', label: '10:30:00' },
        { value: '11:00:00', label: '11:00:00' },
        { value: '11:30:00', label: '11:30:00' },
        { value: '12:00:00', label: '12:00:00' },
        { value: '12:30:00', label: '12:30:00' },
        { value: '13:00:00', label: '13:00:00' },
        { value: '13:30:00', label: '13:30:00' },
        { value: '14:00:00', label: '14:00:00' },
        { value: '14:30:00', label: '14:30:00' },
        { value: '15:00:00', label: '15:00:00' },
        { value: '15:30:00', label: '15:30:00' },
        { value: '16:00:00', label: '16:00:00' },
        { value: '16:30:00', label: '16:30:00' },
        { value: '17:00:00', label: '17:00:00' },
        { value: '17:30:00', label: '17:30:00' },
        { value: '18:00:00', label: '18:00:00' },
        { value: '18:30:00', label: '18:30:00' },
        { value: '19:00:00', label: '19:00:00' },
        { value: '19:30:00', label: '19:30:00' },
        { value: '20:00:00', label: '20:00:00' },
        { value: '20:30:00', label: '20:30:00' },
        { value: '21:00:00', label: '21:00:00' },
        { value: '21:30:00', label: '21:30:00' },
        { value: '22:00:00', label: '22:00:00' },
        { value: '22:30:00', label: '22:30:00' },
    ];

    const validate = async () => {

        let isValid = true;
        const list = slot
        let errors = {};

        if (radioCheck === "") {
            isValid = false
            errors.days = 'Select the days for Consultation'
        }
        if (endDate === '' || startDate === '') {
            isValid = false
            errors.date = 'Choose start and end dates'
        }
        if (list.length < 1) {
            isValid = false
            errors.slots = 'Please add a consultation slot'
        }
        list.map((item) => {
            if (item.from_time.value === '') {
                isValid = false
                errors.slots = 'Add From-time'
            }
            if (item.to_time.value === '') {
                isValid = false
                errors.slots = 'Add To-time '
            }
            if ((item.from_time.value !== '' && item.to_time.value !== '') && (item.from_time.value === item.to_time.value)) {
                isValid = false
                errors.slots = 'From-time and To-time cannot be same'
            }
            if ((item.from_time.value !== '' && item.to_time.value !== '') && (item.from_time.value > item.to_time.value)) {
                isValid = false
                errors.slots = 'From-time cannot exceed To-time'
            }
            if ((item.from_time.value !== '' && item.to_time.value !== '') && (item.token === "")) {
                isValid = false
                errors.slots = 'Enter the Token Number'
            }
            if ((item.from_time.value !== '' && item.to_time.value !== '') && (item.token < 1)) {
                isValid = false
                errors.slots = 'Enter valid Token Number'
            }
            if ((item.from_time.value !== '' && item.to_time.value !== '') && (item.over_token < 0 || item.over_token === '')) {
                isValid = false
                errors.slots = 'Enter valid over booking tokens'
            }
        })

        for (let i = 0; i < list.length; i++) {

            for (let j = 1; j < list.length; j++) {

                if (i != j) {
                    if (list[i].from_time.value === list[j].from_time.value) {
                        isValid = false
                        if (errors.slots === '' || errors.slots === undefined || errors.slots === null) {
                            errors.slots = 'Time slots cannot intersect';
                        }
                    }
                    if (list[i].to_time.value === list[j].to_time.value) {
                        isValid = false
                        if (errors.slots === '' || errors.slots === undefined || errors.slots === null) {
                            errors.slots = 'Time slots cannot intersect';
                        }
                    }
                    if (list[i].from_time.value < list[j].from_time.value && list[i].to_time.value > list[j].to_time.value) {
                        isValid = false
                        if (errors.slots === '' || errors.slots === undefined || errors.slots === null) {
                            errors.slots = 'Time slots cannot intersect';
                        }
                    }
                    if (list[i].from_time.value > list[j].from_time.value && list[i].to_time.value < list[j].to_time.value) {
                        isValid = false
                        if (errors.slots === '' || errors.slots === undefined || errors.slots === null) {
                            errors.slots = 'Time slots cannot intersect';
                        }
                    }
                    if (list[i].from_time.value < list[j].to_time.value && list[i].to_time.value > list[j].to_time.value) {
                        isValid = false
                        if (errors.slots === '' || errors.slots === undefined || errors.slots === null) {
                            errors.slots = 'Time slots cannot intersect';
                        }
                    }
                    if (list[j].from_time.value < list[i].to_time.value && list[j].from_time.value > list[i].from_time.value) {
                        isValid = false
                        if (errors.slots === '' || errors.slots === undefined || errors.slots === null) {
                            errors.slots = 'Time slots cannot intersect';
                        }
                    }
                    if (list[i].from_time.value < list[j].from_time.value && list[j].from_time.value < list[i].to_time.value) {
                        isValid = false
                        if (errors.slots === '' || errors.slots === undefined || errors.slots === null) {
                            errors.slots = 'Time slots cannot intersect';
                        }
                    }
                }


            }
        }

        setError(errors);
        return isValid
    }


    // useEffect(() => {
    //     if (props.paymentDone == "1" || props.paymentDone == "3") {
    //         setIsonline(false)
    //     }
    //     else {
    //         setIsonline(true)
    //     }
    // }, [])

    useEffect(() => {
        if (fromDate !== "" || toDate !== "")
            var time_difference = new Date(toDate).getTime() + 1 - new Date(fromDate).getTime();
        var result = time_difference / (1000 * 60 * 60 * 24);

        const daysOfWeek = [];
        if (result + 1 < 7) {
            const startDate = moment(fromDate)
            const endDate = moment(toDate);

            endDate.add(1, "day");



            let i = 0;

            while (i < 7 && startDate < endDate) {
                daysOfWeek.push(startDate.day());
                startDate.add(1, "day");
                i++;
            }

            setdaysOfWeek(daysOfWeek)
            return daysOfWeek;

        } else {
            setdaysOfWeek([0, 1, 2, 3, 4, 5, 6])
        }

    }, [load])



    const handleSchedule = async () => {

        if (await validate()) {
            const tokenString = sessionStorage.getItem('usertoken');

            let str = tokenString.replace(/["]+/g, '')

            const data = {
                from_date: fromDate,
                to_date: toDate,
                slots: await processSlots(),
                frequency: "daily",
                days: frequency.value === 'daily' ? await processDays() : [],
                // day_of_month: flag === 'month' ? monthDay : null,
                // week_of_month: flag === 'week' ? week.value : null,
                // weekday_of_month: flag === 'week' ? weekDay.value : null,
                is_online: false
            }

            axios.post(`${APIURL}/api/v1/doctor/schedule/`, data, {
                headers: {

                    "Authorization": 'Token ' + str
                }
            })
                .then(res => {

                    if (res.data.status === "success") {
                        alert.success('Added successfully')
                        props.refresh()
                    }
                    else {
                        alert.error(res.data.message || 'Error occured')
                    }

                })
                .catch(err => {
                    alert.error('Error in data submission.Please try again!')
                })
        }

    }

    const processSlots = async () => {
        const arr = slot
        const data = arr.map(item => {
            return (
                {
                    from_time: item.from_time.value,
                    to_time: item.to_time.value,
                    token: item.token,
                    overbooking_count: (item.over_token !== null || item.over_token !== undefined) ? item.over_token : 0
                }
            )
        })

        return data
    }

    const processDays = async () => {
        let list = []
        const data = copy

        if (data.monday === true) {
            list.push('0')
        }
        if (data.tuesday === true) {
            list.push('1')
        }
        if (data.wednesday === true) {
            list.push('2')
        }
        if (data.thursday === true) {
            list.push('3')
        }
        if (data.friday === true) {
            list.push('4')
        }
        if (data.saturday === true) {
            list.push('5')
        }
        if (data.sunday === true) {
            list.push('6')
        }

        return list
    }

    const getMaxToDate = () => {
        if (fromDate) {
            return new Date(moment(fromDate).add(1, "month").toISOString());
        }
        return null;
    };

    const handleStartDate = (date) => {
        setError(currentState => ({
            ...currentState,
            date: ''
        }))

        setStartDate(date);

        let dateUpdated = date;
        if (date !== null) {
            const offset = date.getTimezoneOffset();

            dateUpdated = new Date(date.getTime() - (offset * 60 * 1000))

            let DateExtracted = dateUpdated.toISOString().split('T')[0];

            /*let dateString= DateExtracted.toString(); */
            setFromDate(DateExtracted);
            setLoad(!load)
        }
    }

    const handleToDate = (date) => {
        setError(currentState => ({
            ...currentState,
            date: ''
        }))
        setEndDate(date);

        let dateUpdated = date;
        if (date !== null) {
            const offset = date.getTimezoneOffset();

            dateUpdated = new Date(date.getTime() - (offset * 60 * 1000))

            let DateExtracted = dateUpdated.toISOString().split('T')[0];

            /*let dateString= DateExtracted.toString(); */
            setToDate(DateExtracted);
            setLoad(!load)
        }
    }

    const handleFromChange = (time, index) => {
        setError(currentState => ({
            ...currentState,
            slots: ''
        }))
        let list = slot
        list[index].from_time = time
        setSlot(list)
        setRefresh(!refresh)
    }

    const handleToChange = (time, index) => {
        setError(currentState => ({
            ...currentState,
            slots: ''
        }))
        let list = slot
        list[index].to_time = time
        setSlot(list)
        setRefresh(!refresh)
    }

    const handleToken = (e, index) => {
        setError(currentState => ({
            ...currentState,
            slots: ''
        }))
        let list = slot
        list[index].token = e.target.value
        setSlot(list)
        setRefresh(!refresh)
    }
    const handleOverToken = (e, index) => {
        setError(currentState => ({
            ...currentState,
            slots: ''
        }))
        let list = slot
        list[index].over_token = e.target.value
        setSlot(list)
        setRefresh(!refresh)
    }
    const handleClick = (index) => {
        setError(currentState => ({
            ...currentState,
            days: ''
        }))
        let list = slot
        const data = list.filter((item, i) => {
            return i !== index
        })
        setSlot(data)
        setRefresh(!refresh)
    }

    const handleAdd = () => {
        const list = slot
        list.push({
            from_time: { value: "", label: "" },
            to_time: { value: "", label: "" },
            token: "",
            over_token: ""
        })
        setSlot(list)
        setRefresh(!refresh)
    }



    const handleDays = (e) => {
        setRadioCheck('Validated')
        const val = e.target.name

        setCopy(data => ({ ...data, [val]: !(copy[val]) }))
    }



    const handleChange = (e) => {
        const val = e.target.value;
        if (e.target.value === "true") {
            if (props.paymentDone !== "2" && props.paymentDone !== "3") {
                alert.error("Enter fee for online consultation")
            } else {
                setIsonline(true)
            }
        }
        else {
            if (props.paymentDone == "0") {
                alert.error("Enter fee for consultation")
            } else {
                setIsonline(false)
            }
        }

    }


    return (<>
        <h3 className='sub-title'>Add Schedule</h3>
        <div className='resch-date'>
            <span className='date-content'><i className="fas fa-calendar-alt cal-col"></i>
                {error.date ? <label style={{ margin: 0 }} className="error-label">{error.date}</label> : ' Consultation Date'}
                <div style={{ float: "right" }} className="radio-options">
                    {/* <input
                        style={{ marginTop: "1%" }}
                        type="radio"
                        id="Hospital"
                        name="health"
                        value="false"
                        checked={isOnline === false}
                        onChange={handleChange}
                    /><span>&nbsp;</span>
                    <small htmlFor="hospital">
                        In-person
                    </small>

                    <span>&nbsp;&nbsp;</span>
                    <input
                        style={{ marginTop: "1%" }}
                        type="radio"
                        id="Hospital"
                        name="health"
                        value="true"
                        checked={isOnline === true}
                        onChange={handleChange}
                    /><span>&nbsp;</span>
                    <small htmlFor="hospital">
                        Online
                    </small> */}
                </div>
            </span>
            <div className='consult-flex check-consult'>
                <div className='detail-flex start-margin'>

                    <span className='text-muted font-weight-bold date-align'>Start</span>
                    <div className='from-date'>
                        <DatePicker
                            value={startDate}
                            onChange={date => { handleStartDate(date) }}
                            minDate={new Date()}

                        />
                    </div>
                </div>
                <div className='detail-flex'>
                    <span className='text-muted font-weight-bold date-align'>End</span>
                    <div className='from-date'>
                        <DatePicker
                            value={endDate}
                            onChange={date => { handleToDate(date) }}
                            minDate={startDate}
                            disabled={startDate === ''}
                            maxDate={getMaxToDate()}

                        />
                    </div>
                </div>
            </div>

            <span className='date-content'><i className="fas fa-stethoscope walk-col"></i>
                {error.slots ? <label style={{ margin: 0 }} className="error-label">{error.slots}</label> : 'Consultation Slot'}
                <i onClick={handleAdd} className="fas fa-plus plus-slot"></i></span>
            <div className='check-consult'>
                {
                    slot.length > 0 ?
                        <div className='consult-flex month-align'>
                            <span className='text-muted font-weight-bold head-section'>From</span>
                            <span className='text-muted font-weight-bold head-section'>To</span>
                            <span className='text-muted font-weight-bold head-token'>Tokens</span>
                            <span className='text-muted font-weight-bold head-overtoken'>Overbooking tokens</span>
                        </div>
                        : null
                }

                {
                    slot.map((item, index) => {
                        return (<div className='consult-flex date-align start-margin'>
                            <div className='detail-flex sort-margin'>
                                <Select
                                    value={item.from_time}
                                    onChange={(data) => {
                                        handleFromChange(data, index)
                                    }}
                                    options={timeOptions}
                                    className="select-time"
                                />
                            </div>

                            <div className='detail-flex sort-margin'>

                                <Select
                                    value={item.to_time}
                                    onChange={(data) => {
                                        handleToChange(data, index)
                                    }}
                                    options={timeOptions}
                                    className="select-time"
                                />
                            </div>

                            <div className='detail-flex sort-margin'>

                                <input style={{ backgroundColor: "" }} type='text' className='form-control token-align' value={item.token}
                                    onChange={(data) => handleToken(data, index)}
                                />

                            </div>
                            <div className='detail-flex sort-margin'>

                                <input style={{ backgroundColor: "" }} type='text' className='form-control overtoken-align' value={item.over_token}
                                    onChange={(data) => handleOverToken(data, index)}
                                />

                            </div>
                            <i onClick={() => handleClick(index)} className="fas fa-times align-close"></i>
                        </div>
                        )
                    })
                }
            </div>



            <span className='date-content month-align'><i class="fas fa-user-md doc-icon"></i>
                {error.days ? <label style={{ margin: 0 }} className="error-label">{error.days}</label> : 'Consultation Days'}</span>
            <div className='check-consult'>

                <div className='consult-flex month-align'>
                    <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    <input disabled={!daysOfaWeek.includes(1)} className='checkbox-class' type='checkbox' id='monday' name='monday' checked={copy.monday === true} onChange={handleDays} />
                    <label className='days-class' htmlFor='Monday'>Monday</label>

                    <input disabled={!daysOfaWeek.includes(2)} className='checkbox-class' type='checkbox' id='tuesday' name='tuesday' checked={copy.tuesday === true} onChange={handleDays} />
                    <label className='days-class' htmlFor='Tuesday'>Tuesday</label>

                    <input disabled={!daysOfaWeek.includes(3)} className='checkbox-class' type='checkbox' id='wednesday' name='wednesday' checked={copy.wednesday === true} onChange={handleDays} />
                    <label className='days-class' htmlFor='Wednesday'>Wednesday</label>

                    <input disabled={!daysOfaWeek.includes(4)} className='checkbox-class' type='checkbox' id='thursday' name='thursday' checked={copy.thursday === true} onChange={handleDays} />
                    <label className='days-class' htmlFor='Thursday'>Thursday</label>

                    <input disabled={!daysOfaWeek.includes(5)} className='checkbox-class' type='checkbox' id='friday' name='friday' checked={copy.friday === true} onChange={handleDays} />
                    <label className='days-class' htmlFor='Friday'>Friday</label>

                    <input disabled={!daysOfaWeek.includes(6)} className='checkbox-class' type='checkbox' id='saturday' name='saturday' checked={copy.saturday === true} onChange={handleDays} />
                    <label className='days-class' htmlFor='Saturday'>Saturday</label>

                    <input disabled={!daysOfaWeek.includes(0)} className='checkbox-class' type='checkbox' id='sunday' name='sunday' checked={copy.sunday === true} onChange={handleDays} />
                    <label className='days-class' htmlFor='Sunday'>Sunday</label>

                </div>

            </div>

            <br />
            <br />
            <div className="form-group" style={{ display: 'flex', margin: 'auto' }}>
                <button type="button" className='swirl-butns' style={{ margin: '10px 3px 0px 0px', backgroundColor: '#dc3545' }} onClick={props.onClose}> Cancel </button>
                <button type="submit" className='swirl-butns' style={{ margin: '10px 0px 0px 3px', backgroundColor: '#2b69a3' }} onClick={handleSchedule}>Add </button>
            </div>
        </div >
    </>
    )
}

export default AddSchedule
